<template>
    <section class="why-eco center-align grey section">
        <div class="container">
            <h2 class="center">
                Value, quality and excellent service
            </h2>

            <div class="company-blurb-trustpilot">
                <div class="row flex">
                    <div class="trustpilot-card">
                        <span class="rating"><strong>4.9</strong> out of 5 on</span>
                            <img src="../assets/images/trustpilot/trustpilot-logo.svg" />
                        <span class="review-link">Based on <a href="https://uk.trustpilot.com/review/ecowebhosting.co.uk">562 reviews</a></span>
                    </div>
                    <div class="text-block">
                        Our team comes from some of the biggest brands in the industry, who know what it takes to provide reliable and fast web hosting. With Eco Web Hosting, we wanted to create a company that values quality products, exceptional customer service, and a commitment to the environment over acquisitions and profit margins.
                    </div>
                </div>
            </div>
            <div class="row trustpilot-row">
                <!-- <trustpilot-trustbox review-topic="ewh-gc" /> -->
                <div class="trustpilot-section">
                    <a href="https://www.trustpilot.com/reviews/62da80424c35e69ec5168600" class="review">
                        <img src="../assets/images/trustpilot/trustpilot-5-stars.svg" />
                        <span class="date">22nd July 2022</span>
                        <span class="title">“No hesitation — the best hosting”</span>
                        <p class="quote">If you want old-style humans sorting out your issues, then look no further. No hesitation — the best hosting for independent websites and new developers.</p>
                        <span class="name">Greg</span>
                    </a>

                    <a href="https://www.trustpilot.com/reviews/62cee4204c35e69ec50e1201" class="review">
                        <img src="../assets/images/trustpilot/trustpilot-5-stars.svg" />
                        <span class="date">13th July 2022</span>
                        <span class="title">“Great ethical web host!”</span>
                        <p class="quote">They’re always quick to respond to questions I have, and always give great service!</p>
                        <span class="name">Eva McHugh</span>
                    </a>                      
                
                    <a href="https://www.trustpilot.com/reviews/6297a02dd557309563087720" class="review">
                        <img src="../assets/images/trustpilot/trustpilot-5-stars.svg" />
                        <span class="date">1st June 2022</span>
                        <span class="title">“Prompt and helpful”</span>
                        <p class="quote">I chose Eco Web Hosting because they were a reasonable price, low carbon, and based in the UK. Then I found out they had real people that could actually help!</p>
                        <span class="name">Graham</span>
                    </a>
                    
                
                    <a href="https://www.trustpilot.com/reviews/62827ad3e55124e5d9b69fc5" class="review">
                        <img src="../assets/images/trustpilot/trustpilot-5-stars.svg" />
                        <span class="date">16th May 2022</span>
                        <span class="title">“Amazing customer service”</span>
                        <p class="quote">Probably the most friendly web hosting I have ever had.</p>
                        <span class="name">Ghilliesuit Gaming</span>
                    </a>
                        
                </div>

                
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TrustpilotTrustbox', 
    mounted() {
        //this.loadTrustbox();
    }
};
</script>

<style lang="scss" scoped>

.why-eco {
    @media (min-width:768px) {
        padding-bottom:30px;
    }
    
}
    .company-blurb-trustpilot {
        .row {
            display:flex;
            align-items:center;
            width:1070px;
            margin-bottom:20px;
            max-width: 95%;
            flex-direction:column;
        
        @media (min-width: 700px) {
            margin-bottom:70px;
            flex-direction:row;
        }
    }

    /* New Trustpilot block */
    .trustpilot-card {
        display:flex;
        flex-direction:column;
        min-width:250px;
        max-width:90%;
        /*height:125px;*/
        background-color:#e2e2e2;
        padding:10px 45px 15px;
        justify-items:center;
        border-radius: 12px;
        align-items:center;
        margin:0 auto;
        margin-bottom: 25px;
        zoom: 0.7;

         @media (min-width: 700px) {
            zoom: 1;
            margin-right: 40px;
            margin-bottom:0px;
        }
        

        .rating {
            display:flex;
            align-items:center;
            font-size:18px;
            color:#0B0B0B;
            strong {
                font-size:28px;
                color: #187E5F;
                padding-right:7px;
            }
        }

        img {
            height: 40px;
            max-width: 100%;
            margin-bottom: 3px;
            margin-top: -5px;
        }

        .review-link {
            color: #20211D;
            font-size:16px;

            a {
                color: #20211D;
                font-weight:bold;
                text-decoration: underline;
            }
        }
    }

    

    .text-block {
        color: #191916; 
        text-align:center;

        padding: 0 15px;
        font-size:14px;

         @media (min-width: 700px) {
             font-size:16px;
             text-align:left;
             padding: 0px;
             
         }

         @media (min-width:992px ){
             font-size:18px;
         }
    }
}

.trustpilot-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    .trustpilot-section {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        a.review {
            display: flex;
            flex-direction: column;
            flex: 1;
            position: relative;
            margin-bottom:30px;
            background: white;
            padding: 20px 20px 15px;
            color: #3A3B3E;
            transition: 0.2s;
            margin: 0 10px 20px;
            min-width: 90%;
            transition: 0.3s;
            top:0px;
            cursor:pointer;

            &:last-child {
                margin-bottom:0px;
                @media (min-width:600px) {
                    margin-bottom: 30px;
                }
            }

            &:hover {
                @media (min-width:600px) {
                    top: -15px;
                    transition: 0.3s;
                    cursor:pointer;
                }
            }

            @media (min-width:600px) {
                min-width:35%;
                max-width: 50%;
            }

            @media (min-width:992px) {
                padding: 35px 26px 30px;
                margin: 0 10px 30px;
                min-width:20%;
                max-width:25%;
            }

            &:hover {
                transition: 0.2s;
            }

            img {
                width:70%;
                display:block;
                margin: 0 auto 5px;
                max-width:100px;

                @media (min-width:600px) {
                    max-width:150px;
                }
            }

            .date {
                font-style: italic;
                font-size: 14px;
            }

            .title {
                display: block;
                font-weight: bold;
                margin-bottom: 4px;
                font-size: 16px;
                margin-top: 4px;
                line-height: initial;

                @media (min-width:992px) {
                    margin-bottom: 7.5px;
                    font-size:16px;
                    margin-top:14px;
                }
            }

            p {
                margin-top: 0px;
                margin-bottom: 5px;
                font-size:14px;
            }

            .name {
                font-weight:bold;
                font-size:14px;
            }
        }
    }
}
</style>